import { useTranslation } from '@exam-room/translations';
import { type PropsWithChildren } from 'react';

import { Card } from '../../../../../components';

import { EXAM_RESULT_ICON_VARIANT_MAP, EXAM_RESULT_TITLE_VARIANT_MAP } from './constants';
import { type ExamPreviewResultVariant } from './types';

interface ExamPreviewResultCardProps extends PropsWithChildren {
  variant: ExamPreviewResultVariant;
}

function ExamPreviewResultCard(props: Readonly<ExamPreviewResultCardProps>) {
  const { variant, children } = props;

  const Icon = EXAM_RESULT_ICON_VARIANT_MAP[variant];
  const title = EXAM_RESULT_TITLE_VARIANT_MAP[variant];

  const { t } = useTranslation();
  return (
    <Card className='mx-auto w-full p-10'>
      <div className='mx-auto flex w-105 flex-col items-center gap-6 text-center'>
        <Icon />
        <div className='flex flex-col gap-3'>
          <h3>{t(title)}</h3>
          <span>
            <p className='text-text-secondary'>{t('examPreviewResultCard.detail')}</p>
            <p className='text-text-secondary'>{t('examPreviewResultCard.description')}</p>
          </span>
        </div>
        {children}
      </div>
    </Card>
  );
}

export default ExamPreviewResultCard;
